import {
    UPLOAD_MANAGER_ADD,
    UPLOAD_MANAGER_REMOVE,
    UPLOAD_MANAGER_SET_AUTO_REMOVAL,
} from './constants'

const defaultState = {
    autoRemoval: true,
    uploads: [],
}

function immutableDelete(array, index) {
    return array.slice(0, index).concat(array.slice(index + 1))
}

function getIndex(array, key) {
    return array.findIndex((item) => item.params.Key === key)
}

const uploadManagerReducer = (state = defaultState, action) => {
    switch (action.type) {
        case UPLOAD_MANAGER_ADD:
            return {
                ...state,
                uploads: [...state.uploads, action.upload],
            }

        case UPLOAD_MANAGER_REMOVE:
            return {
                ...state,
                uploads: immutableDelete(state.uploads, getIndex(state.uploads, action.key)),
            }

        case UPLOAD_MANAGER_SET_AUTO_REMOVAL:
            return {
                ...state,
                autoRemoval: action.bool,
            }

        default:
            return state
    }
}

export default uploadManagerReducer
